'use strict';

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _uuid = require('uuid');

var _applicationState = require('../../utils/applicationState');

var _htmlUtils = require('../../utils/htmlUtils');

var _htmlUtils2 = _interopRequireDefault(_htmlUtils);

var _reporter = require('../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleError(slot, errorCallback, message) {
  if (slot && slot.formatDefinition && slot.formatDefinition.reportError) {
    _reporter2.default.fail(slot, message);
  }
  if (errorCallback) {
    errorCallback(message);
  }
}

var truexNetworkController = {
  init: function init() {
    _htmlUtils2.default.addScript('https://static.truex.com/js/client.js');
  },
  serveAd: function serveAd(params) {
    return new Promise(function (resolve) {
      var slot = params.slot,
          elementId = params.elementId,
          campaignId = params.campaignId,
          campaignKey = params.campaignKey,
          unlockToken = params.unlockToken,
          onStart = params.onStart,
          onCredit = params.onCredit,
          onFinish = params.onFinish,
          onError = params.onError,
          callbackHandler = params.callbackHandler;


      if (!global.truex || !slot || !elementId || !campaignKey || !(0, _applicationState.getState)(_applicationState.State.rtid)) {
        handleError(slot, onError, 'bad initialization');
        resolve();
        return;
      }

      slot.formatDefinition = (0, _find2.default)(slot.formats, function (format) {
        return format.adProvider === 'truex';
      });
      if (!slot.formatDefinition) {
        handleError(slot, onError, 'bad initialization');
        resolve();
        return;
      }

      slot.requestId = (0, _uuid.v4)();
      slot.formatDefinition.adUnitId = campaignKey;
      slot.campaignId = campaignId;

      if (callbackHandler) {
        // invoked in gemini-web when UnlockAdSlot unmounts (common/components/ads/UnlockAdSlot.js)
        callbackHandler.closeCallback = function (isCreditUnlocked) {
          if (!slot.isActive) {
            return;
          }

          if (!isCreditUnlocked) {
            _reporter2.default.xButton(slot);
          }

          if (!slot.credit) {
            _reporter2.default.skip(slot);
          }
        };

        // invoked in gemini-web if unlock credit fails (common/components/ads/UnlockAdSlot.js)
        callbackHandler.handleError = function (error) {
          handleError(slot, onError, error);
          resolve();
        };
      }

      var options = {
        network_user_id: (0, _applicationState.getState)(_applicationState.State.rtid),
        partner_config_hash: campaignKey
      };

      global.truex.client(options, function (client) {
        if (slot.formatDefinition.reportRequest) {
          _reporter2.default.request(slot);
        }

        client.requestActivity(function (activity) {
          try {
            if (activity) {
              activity.onFinish(function () {
                _reporter2.default.end(slot);
                if (onFinish) {
                  onFinish({
                    activity: activity
                  });
                }
              });

              activity.onCredit(function (engagement) {
                var unlockProviderData = global.btoa(engagement.signature_argument_string + '&signature=' + encodeURIComponent(engagement.signature));

                _reporter2.default.credit(slot);
                slot.credit = true;
                if (onCredit) {
                  onCredit({
                    campaignId: campaignId,
                    unlockProviderData: unlockProviderData,
                    unlockToken: unlockToken
                  });
                }
              });

              client.loadActivityIntoContainer(activity, slot.elementId, {
                width: activity.window_width,
                height: activity.window_height
              });

              slot.isActive = true;
              slot.currentDimensions = [activity.window_width, activity.window_height];
              _reporter2.default.start(slot);
              if (onStart) {
                onStart(activity.window_width, activity.window_height);
              }
            } else {
              handleError(slot, onError, 'no unlock activity');
            }
          } catch (error) {
            handleError(slot, onError, error);
          }
        });
        resolve();
      });
    });
  }
};

module.exports = truexNetworkController;